function Personal(){  
    return <>

        <div className="OutletPersonal">
        <div className="wholeCard">
                {/* <h1>In Summary</h1> */}
            <div className="compCards">  
                <div className="cardHeading"><h2>Personal Information</h2></div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Gender</b></p></div>
                    <div className="InpuTvalue">Male</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Date Of Birth</b></p></div>
                    <div className="InpuTvalue">02/04/1994</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Hispanic/Latino</b></p></div>
                    <div className="InpuTvalue">No</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Race</b></p></div>
                    <div className="InpuTvalue">N/A</div>

                </div>

                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Highest Academic Qualification</b></p></div>
                    <div className="InpuTvalue">Masters Degree</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Nationality</b></p></div>
                    <div className="InpuTvalue">Zambian</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Social Security Number</b></p></div>
                    <div className="InpuTvalue">417600/11/2</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Phone Number</b></p></div>
                    <div className="InpuTvalue">+260971875555</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Home Address</b></p></div>
                    <div className="InpuTvalue">1532 Magwero, Chipata</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Original Hire Date</b></p></div>
                    <div className="InpuTvalue">22/03/2021</div>

                </div>

              

            </div>
          
           
        </div>
        <div className="wholeCard">
                {/* <h1>In Summary</h1> */}
            <div className="compCards">  
   

                <div className="cardHeading"><h3>Next-of-Kin Information</h3></div>

                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Full Name</b></p></div>
                    <div className="InpuTvalue">Steward Phiri</div>

                </div>

                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Relationship</b></p></div>
                    <div className="InpuTvalue">Uncle</div>

                </div>

                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Nationality</b></p></div>
                    <div className="InpuTvalue">Zambian</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Social Security Number</b></p></div>
                    <div className="InpuTvalue">517600/11/2</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Phone Number</b></p></div>
                    <div className="InpuTvalue">+260970000000</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Home Address</b></p></div>
                    <div className="InpuTvalue">1532 Mtendere, Lusaka</div>

                </div>

              

            </div>
          
           
        </div>
        

       

        </div>
        
    
    </>

}

export default Personal;